import React, { useEffect, useState } from 'react'
import './inscriptionForm.css';
import { useParams } from 'react-router-dom'
import { useAppContext } from '../../App';
import { Box, Button, Text, useTheme } from '@chakra-ui/react';
import { formatTextForCard } from '../../utils/functions';
import InscriptionFormCustom from './inscriptionFormCustom/inscriptionFormCustom';
import SpecificCourseDescription from './specificCourse/specificCourseDescription';
import OtherCoursesStepCard from './otherCoursesStep/otherCoursesStepCard';
import CarouselForComponents from '../../components/carouselCustom/carouselCustom';
import SlideCarouselLittle from '../../components/carouselSlides/trends/slideCarouselLittle';
import RatingCustom from '../../components/ratingCustom/ratingCustom';
import CommentCard from './commentCard/commentCard';
import { FaListCheck, FaPaperPlane } from 'react-icons/fa6';
import { DropdownSimple } from './dropdownSimple/dropdownSimple';
import { GoalsComponent } from './goalsComponent/goalsComponent';
import ProgramComponent from './program/programComponent';
import { getCourseById, getCoursesByCategory, getCoursesForTrayectory, getTrayectoryInfo } from '../../utils/dataFetch';
import CustomLoader from '../../components/loader/customLoader';

export default function InscriptionForm() {
    const {type, categoryName, IdCurso} = useParams();
    const {isMobile} = useAppContext();
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [coursesByCategory, setCoursesByCategory] = useState(null);
    const [trayectoryInfo, setTrayectoryInfo] = useState(null);
    const theme = useTheme();
    const renderType = type;
    const isRenderTrayecto = ['trayecto profesional', 'secretariados'].includes(type.toLocaleLowerCase());
    const style = styles(theme, isMobile);   
    const arrayComments = [
      {
        name: "Joaco Chemille",
        description: "Esta es la descripcion de la card",
        rating: 3,
      },
      {
        name: "Freddy Lezama",
        description: "Esta es la descripcion de la card",
        rating: 4,
      },
      {
        name: "Hernan",
        description: "Esta es la descripcion de la card",
        rating: 2,
      },
      {
        name: "Sol Marchiori",
        description: "Esta es la descripcion de la card",
        rating: 5,
      }
    ]
    const ratings = {
      1: 0,
      2: 20,
      3: 10,
      4: 60,
      5: 60,
    };

  useEffect(()=>{
    setLoading(true)
    getCourseById(IdCurso).then(setSelectedCourse);
  },[IdCurso, categoryName, type])

  useEffect(() => {    
    if(isRenderTrayecto){
      getCoursesForTrayectory(IdCurso).then(setCoursesByCategory)
    }
    else{
      getCoursesByCategory(categoryName).then(res => {
        setCoursesByCategory(res.filter(course => course.id !== IdCurso))
      })
    }

    selectedCourse && 
    getTrayectoryInfo(IdCurso, selectedCourse?.IdCategoria, !isRenderTrayecto).then(setTrayectoryInfo)

    setLoading(false)
  },[selectedCourse])
  
  const nextCoursesTitleStyle = 
  isRenderTrayecto? {
    fontSize: "2rem",
    textAlign: isMobile?'center': 'left',
    padding: "2rem",
  }:{}

  return (
    !selectedCourse || loading?
    <CustomLoader 
      loaderText='CARGANDO EL CURSO...' 
      customStyles={{
        text: {
          fontSize: isMobile? '1rem' : "2rem",
          fontWeight: "bold",
          color: theme.color.text.secondary
        }
      }}
    />:
    <div style={style.container} className='quicksand-semibold'>
      <Text style={style.title}>
        {`${isMobile? '':renderType + '/'}${isMobile? '': categoryName + '/'}`}
        <Text style={style.highlight}>{formatTextForCard('title', selectedCourse?.NombreCurso)}</Text>
      </Text>
      <div style={style.infoAndFormContainer}>
        <SpecificCourseDescription 
          imgSavedSrc={selectedCourse?.IdImagenCurso}
          renderSpecific={selectedCourse?.NombreCurso}
          certifications={selectedCourse?.certificaciones}
          description={selectedCourse?.Descripcion}
          modesArray={selectedCourse?.modalidades}
          prices={selectedCourse?.precios}
          lastingTime={selectedCourse?.Duracion}
        />
        {!isMobile && <InscriptionFormCustom IdTipoContacto={2}/>}
      </div>
      <DropdownSimple 
        buttonText='+ DIRIGIDO A'
        defaultOpen={true} // <-- Agrega esto
        componentToRender={() => 
          !selectedCourse?.Dirigido? <></>:
          <Text style={style.sectionDescription}>
            {selectedCourse?.Dirigido}
          </Text>
        }
        customStyles={{
          buttonText:{
            ...style.section
          }
        }}
      />
      <DropdownSimple 
        buttonText='+ OBJETIVOS'
        customStyles={{
          buttonText:{
            ...style.section
          }
        }}
        componentToRender={() => GoalsComponent(selectedCourse?.Objetivos)}
      />
      <DropdownSimple 
        buttonText='+ PROGRAMA'
        componentToRender={() => ProgramComponent({temas: selectedCourse?.temas || []})}
        customStyles={{
          buttonText:{
            ...style.section
          }
        }}
      />
      {isMobile && <InscriptionFormCustom IdTipoContacto={2} />}

      <Box as='div' display={'flex'} flexDirection={isRenderTrayecto? 'column-reverse' : 'column'}>
        <div>
          {trayectoryInfo?.length > 0 &&
            <Text style={style.section2}>
              {isRenderTrayecto?
              'Otros Trayectos Profesionales' : 
              'Este Curso Forma parte de los siguientes trayectos profesionales'
              }
            </Text>
          }
          <CarouselForComponents qtyPerView={isMobile? 1 : 3} style={style.stepsContainer}>
            {trayectoryInfo?.map((step, index) => (
                <OtherCoursesStepCard item={step} category={categoryName} type={type}/>
            ))}
          </CarouselForComponents>
        </div>
        { false && 
          <>
            <Text style={style.ratingText}>Comentarios de Estudiantes</Text>
            <Box style={style.ratingContainer} >
              <RatingCustom ratings={ratings} />
              <Box style={{width:isMobile? '100%' : '60%'}}>
                <Text as="span" fontWeight="bold" fontSize={'1rem'} >Comentarios</Text>
                <CarouselForComponents qtyPerView={isMobile? 1 : 2} customStyles={style.commentCarousel}>
                  {arrayComments.map(comment =>
                    <CommentCard name={comment.name} description={comment.description} rating={comment.rating}/>
                  )}
                </CarouselForComponents>
              </Box>
            </Box>
          </>
        }
        <Box as='div'>
          {coursesByCategory?.length > 0 &&
            <Text style={{...style.section, borderBottomWidth: 0, ...nextCoursesTitleStyle}} className='sansation-bold'>
              {isRenderTrayecto?'Accedé a este Trayecto ﬁnalizando los siguientes cursos:':'OTROS CURSOS RELACIONADOS'}
            </Text>
          }
          <CarouselForComponents qtyPerView={isMobile? 1 : 3} style={style.stepsContainer}>
            {coursesByCategory?.map(({id,name, description, duracion, modalidades}, index) => {
              return(
              <SlideCarouselLittle
                key={`slide-other-courses-${index}`}
                cardTitle={formatTextForCard('title', name)}
                cardDescription={formatTextForCard('description', description)}
                showButtonMore={false}
                customStyles={style.cardOtherCourses}
                buttonRedirectTo={`/formulario-inscripcion/${type}/${categoryName}/${id}`}
                period={duracion}
                modes={modalidades}
              />
            )})}
          </CarouselForComponents>
        </Box>
      </Box>
      <Button 
  className="titilar-boton"
  position={"fixed"} 
  bottom={isMobile ? 90 : 90} 
  right={isMobile? 5:5} 
  zIndex={100}
  borderRadius={50}
  width={isMobile?'3rem':'4rem'}
  height={isMobile?'3rem':'4rem'}
  color={theme.color.text.primary}
  backgroundColor={theme.background.tertiary}
  onClick={() => {
    const formSection = document.getElementById("inscription-form-id");
    formSection.scrollIntoView({ behavior: "smooth" });
  }}
>
  <FaPaperPlane/>
</Button>
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container: {
    padding: "5vh",
    paddingLeft: isMobile? "5vh":"20vh",
    paddingRight: isMobile? "5vh":"20vh",
  },
  title: {
    display: "flex",
    flexDirection: "row",
    fontSize: isMobile? "1rem":"1rem",
    width: "100%",
    color: theme.color.text.quaternary,
  },
  highlight: {
    color: theme.color.text.tertiary,
  },
  infoAndFormContainer: {
    display: "flex",
    flexDirection: isMobile? "column-reverse":"row",
    justifyContent: "space-between",
    marginTop: "5vh",
  },
  section: {
    padding: "1rem",
    fontSize: "1rem",
    color: theme.color.text.secondary,
    borderBottomWidth: 1,
    borderBottomColor: theme.color.text.secondary,
  },
  section2: {
    fontSize: "1.5rem",
    marginTop: "2vh",
    paddingLeft: "1rem",
    width: isMobile?'100%':'60%',
    color: theme.color.text.primary,
    backgroundColor: theme.background.secondary
  },
  sectionDescription: {
    fontSize: "1rem",
    color: theme.color.text.grey,
    paddingTop: "0.5rem",
    borderBottomWidth: 1,
    paddingBottom: '0.5rem',
    borderBottomColor: theme.color.text.secondary,
  },
  infoContainer: {},
  ratingContainer: {
    display: "flex",
    flexDirection: isMobile?"column":"row",
    justifyContent:'center',
    alignItems: "center",
    marginTop: "5vh",
    marginBottom: "5vh",
    width:"100%",
  },
  commentCarousel:{
    width: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    borderTop: '1px solid black'
  },
  stepsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  ratingText: {
    fontSize: "1.5rem",
    textAlign: isMobile ? "center" : "left",
    color: theme.color.text.secondary,
  },
  cardOtherCourses: {
  container: {
    border: '1px solid',
    borderRadius: 0,
    borderColor: theme.color.text.secondary,
   // maxHeight: '20vh', // Elimina o comenta esta línea para permitir crecer en altura
    padding: 20
  },
  titleAndImgContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
    padding: 0
  },
  title: {
    flex: 1,
    fontSize: isMobile ? "clamp(0.85rem, 2.5vw, 1.1rem)" : "clamp(0.95rem, 1.2vw, 1.3rem)",
    lineHeight: 1.15,
    color: theme.color.text.tertiary,
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    textAlign: "center",
    margin: 0,
    padding: 0,
    // width: "100%", // Elimina esta línea
    // maxWidth: "100%", // Elimina esta línea
  },
  img: isMobile
    ? { display: 'none' }
    : { width: 'auto', maxWidth: '60px', height: 'auto', flexShrink: 0 },
  cardFooter: {
    flexDirection: isMobile ? 'column' : 'row',
  },
  textDiv: {
    width: isMobile ? '100%' : '30%',
    maxWidth: isMobile ? '100%' : '40%',
    fontSize: '1rem',
    borderWidth: isMobile ? 0 : 1,
    padding: 0
  },
  slideButton: isMobile ? {} : {
    height: '5vh'
  }
}
});